import Vue from "vue";
import Vuex from "vuex";

import currentTournament from "./modules/currentTournament";
import currentTournamentValo from "./modules/currentTournamentValo";
import bracket from "./modules/bracket";
import currentUser from "./modules/CurrentUser";
import subTournaments from "./modules/subTournaments";

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    currentTournament,
    bracket,
    currentUser,
    subTournaments,
    currentTournamentValo
  },
});
